import { tv } from 'tailwind-variants';

export const nameBall = tv({
  base: 'flex justify-center items-center rounded-circular font-bold uppercase',
  variants: {
    size: {
      mini: 'w-3 h-3 text-xs',
      small: 'w-6 h-6 text-sm',
      tiny: 'w-8 h-7 text-xs',
      regular: 'w-12 h-12 text-md',
      large: 'w-16 h-16 text-lg',
      profile: 'w-40 h-40 text-lg',
    },
    color: {
      primary: 'bg-color-medium text-brand-color-primary-pure',
      mono: 'bg-color-medium text-brand-color-primary-pure',
    },
  },
});
